<template>
	<article
		class="d-frontpage-uk"
		:class="{
			'd-frontpage--no-footer-gap': !hasFooterGap,
		}"
	>
		<FrontpageHeaderUk :intro="intro" :spot="introSpot" />

		<ScopedColorTheme class="w-full px-layout-margin" theme="blue">
			<FrontpageExperts
				v-if="
					experts &&
					experts.content &&
					experts.content.items &&
					experts.content.items.length
				"
				:block="experts"
			/>

			<FrontpageThemes
				v-if="
					publications &&
					publications.items &&
					publications.items.length
				"
				class="c-frontpage-uk__theme--publication mt-xl/v"
				v-bind="publications"
			/>
			<FrontpageThemes
				v-if="themes && themes.items && themes.items.length"
				class="mt-xl/v"
				v-bind="themes"
			/>
			<FrontpageAreas
				v-if="areas && areas.items && areas.items.length"
				class="mt-xl/v mb-4xl/v"
				v-bind="areas"
			/>
			<FrontpageFocus
				v-if="focus && focus.items && focus.items.length"
				class="mt-xl/v"
				:no-bottom-line="expertsLast"
				v-bind="focus"
			/>
		</ScopedColorTheme>
	</article>
</template>

<script>
import ScopedColorTheme from '~/components/main/ScopedColorTheme';
import FrontpageHeaderUk from '~/components/main/FrontpageHeaderUk';
import FrontpageAreas from '~/components/main/FrontpageAreas';
import FrontpageFocus from '~/components/main/FrontpageFocus';
import FrontpageThemes from '~/components/main/FrontpageThemes';
import FrontpageExperts from '~/components/main/FrontpageExperts';

export default {
	name: 'MainFrontpageUk',

	components: {
		ScopedColorTheme,
		FrontpageHeaderUk,
		FrontpageAreas,
		FrontpageFocus,
		FrontpageThemes,
		FrontpageExperts,
	},

	inheritAttrs: false,

	props: {
		intro: Object,
		spot: Object,
		introSpot: {
			type: Object,
			default: null,
		},
		areas: {
			type: Object,
			default: null,
		},
		focus: {
			type: Object,
			default: null,
		},
		publications: {
			type: Object,
			default: null,
		},
		experts: {
			type: Object,
			default: null,
		},
		themes: {
			type: Object,
			default: null,
		},
	},

	computed: {
		expertsLast() {
			if (
				this.focus &&
				!this.themes &&
				!this.experts?.content?.items?.length
			) {
				return true;
			}
			return false;
		},
		lastBlockIsGrayBlock() {
			if (this.focus && !this.themes) {
				return true;
			}
			return !!this.experts?.content?.items?.length;
		},

		hasFooterGap() {
			if (this.lastBlockIsGrayBlock) {
				return false;
			}

			return true;
		},
	},
};
</script>
<style lang="postcss">
.c-frontpage-uk__theme--publication {
	& .c-card-item__image,
	.c-card-item__date-stamp,
	.c-card-item__link-indicator,
	.c-card-item__areas {
		display: none !important;
	}
}
</style>
